import { inject, Injectable } from '@angular/core';
import {
  VesselActivityPhaseForm,
  VesselActivityPhaseItem,
  VesselActivityRecord,
  VesselActivityRecordAuditLog,
  VesselActivityRecordListParams,
  VesselActivityRecordUpdateBody,
} from '@app/domain/entities/vessel-activity-phase.entity';
import { VesselActivityPhaseRepository } from '@app/domain/repositories/vessel-activity-phase.repository';
import { PaginatedResponse } from '@app/shared/models/global.model';
import { map, Observable } from 'rxjs';
import { VesselActivityPhaseService } from '../api-clients/vessel-activity-phase.service';
import { mapVesselHotoElementTree } from '../mappers/vessel-hoto-form.mapper';

@Injectable()
export class VesselActivityPhaseRepositoryImpl implements VesselActivityPhaseRepository {
  private readonly _vesselActivityPhaseService = inject(
    VesselActivityPhaseService
  );

  getPhases(vesselActivityId: number): Observable<VesselActivityPhaseItem[]> {
    return this._vesselActivityPhaseService.getPhases(vesselActivityId);
  }

  getRecords(
    vesselActivityId: number,
    params: VesselActivityRecordListParams
  ): Observable<PaginatedResponse<VesselActivityRecord>> {
    return this._vesselActivityPhaseService
      .getRecords(vesselActivityId, params)
      .pipe(
        map(response => ({
          ...response,
          data: (response.data ?? []).map(mapVesselHotoElementTree),
        }))
      );
  }

  getPhaseForm(
    vesselActivityId: number,
    configId: number
  ): Observable<VesselActivityPhaseForm> {
    return this._vesselActivityPhaseService
      .getPhaseForm(vesselActivityId, configId)
      .pipe(map(form => form && mapVesselHotoElementTree(form)));
  }

  createRecord(
    vesselActivityId: number,
    configId: number,
    body: VesselActivityRecordUpdateBody
  ): Observable<void> {
    return this._vesselActivityPhaseService.createRecord(
      vesselActivityId,
      configId,
      body
    );
  }

  updateRecord(
    recordId: number,
    body: VesselActivityRecordUpdateBody
  ): Observable<void> {
    return this._vesselActivityPhaseService.updateRecord(recordId, body);
  }

  deleteRecord(recordId: number): Observable<void> {
    return this._vesselActivityPhaseService.deleteRecord(recordId);
  }

  getRecordAuditLogs(
    recordId: number
  ): Observable<VesselActivityRecordAuditLog[]> {
    return this._vesselActivityPhaseService.getRecordAuditLogs(recordId);
  }
}
